import React, { useEffect } from "react";
import cityLogo from "../Images/logo.png";

function HeaderUser() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="translator-holder">
            <div className="logo">
              {/* <img src={cityLogo} width="360" height="118" /> */}
              <svg
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                className="img-fluid"
                y="0px"
                viewBox="0.6 54.5 148.9 41.2"
                enableBackground="new 0.6 54.5 148.9 41.2"
                alt="Tempur-Pedic"
              >
                <g>
                  <g>
                    <polygon
                      fill="#3c4652"
                      points="4.6,82.9 0.9,82.9 0.9,79.9 12.3,79.9 12.3,82.9 8.6,82.9 8.6,95.1 4.6,95.1  "
                    />
                    <polygon
                      fill="#3c4652"
                      points="13.5,79.9 24.2,79.9 24.2,82.8 17.5,82.8 17.5,86 23.8,86 23.8,88.8 17.5,88.8 17.5,92.2 24.4,92.2 24.4,95.1 13.5,95.1  "
                    />
                    <polygon
                      fill="#3c4652"
                      points="25.9,79.9 32.3,79.9 35.5,90 35.5,90 38.9,79.9 45,79.9 45,95.1 41.1,95.1 41.1,83.5 41.1,83.5 37.2,95.1 33.5,95.1 29.8,83.5 29.7,83.5 29.8,95.1 25.9,95.1  "
                    />
                    <path
                      fill="#3c4652"
                      d="M47.2,79.9H52c4.6,0,6.8,1.6,6.8,5c0,3-2.3,4.9-6,4.9h-1.6v5.3h-4.1V79.9z M51.2,86.9h1.1 c1.4,0,2.5-0.5,2.5-2.1c0-1.5-1.1-2-2.5-2h-1.1V86.9z"
                    />
                    <path
                      fill="#3c4652"
                      d="M73.3,89.3c0,4.1-2.7,6-6.6,6c-4,0-6.6-1.8-6.6-6v-9.4h4.1v8.7c0,2,0.6,3.7,2.6,3.7s2.6-1.7,2.6-3.7v-8.7 h4.1L73.3,89.3L73.3,89.3z"
                    />
                    <path
                      fill="#3c4652"
                      d="M75,79.9h7.2c2.7,0,4.9,1.2,4.9,3.8c0,2-1,3.4-2.9,3.8v0c1.3,0.4,1.4,1.5,2.2,3.4l1.5,4.1h-4.2l-0.9-2.7 c-0.8-2.6-1.3-3.3-2.9-3.3h-0.8v6H75L75,79.9L75,79.9z M79,86.2H80c1.3,0,2.9,0,2.9-1.7c0-1.4-1.4-1.7-2.9-1.7H79V86.2z"
                    />
                    <path
                      fill="#3c4652"
                      d="M95.3,79.9h4c3.1,0,5.7,1.1,5.7,4.6c0,3.4-2.6,4.6-5.3,4.6h-2.1v6.1h-2.2L95.3,79.9L95.3,79.9z M97.4,87.1 h2.2c1.3,0,3-0.7,3-2.7c0-1.9-2-2.6-3.4-2.6h-1.8V87.1z"
                    />
                    <path
                      fill="#3c4652"
                      d="M116.3,79.9h4.5c4.5,0,8.1,2.8,8.1,7.5c0,5.1-3.1,7.7-8.1,7.7h-4.5V79.9z M118.5,93.2h2.3 c3.7,0,5.8-1.8,5.8-5.7c0-3.5-2.4-5.6-5.5-5.6h-2.5L118.5,93.2L118.5,93.2z"
                    />
                    <rect
                      x={130.4}
                      y={79.9}
                      fill="#3c4652"
                      width={2.2}
                      height={15.1}
                    />
                    <path
                      fill="#3c4652"
                      d="M145.3,82.5c-1-0.6-2-0.8-3.1-0.8c-3.5,0-5.8,2.5-5.8,5.9c0,3.5,2.6,5.9,5.7,5.9c1.1,0,2.5-0.3,3.3-0.7 l0.1,2.1c-1.2,0.5-2.6,0.6-3.5,0.6c-4.8,0-8-3.1-8-7.9c0-4.7,3.4-7.8,8-7.8c1.2,0,2.3,0.2,3.4,0.6L145.3,82.5z"
                    />
                    <path
                      fill="#3c4652"
                      d="M146.9,81c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2s-0.6,1.2-1.2,1.2S146.9,81.7,146.9,81 M149,81 c0-0.6-0.4-1-0.9-1s-0.9,0.4-0.9,1s0.4,1,0.9,1C148.6,82,149,81.6,149,81 M147.7,80.3h0.5c0.3,0,0.5,0.1,0.5,0.4 c0,0.2-0.1,0.4-0.4,0.4l0.4,0.6h-0.3l-0.4-0.6h-0.1v0.6h-0.3L147.7,80.3L147.7,80.3z M147.9,80.9h0.2c0.1,0,0.3,0,0.3-0.2 c0-0.2-0.1-0.2-0.3-0.2h-0.2V80.9z"
                    />
                    <rect
                      x={87.6}
                      y={87.1}
                      fill="#3c4652"
                      width={5.9}
                      height={2}
                    />
                    <polygon
                      fill="#3c4652"
                      points="106.3,79.9 114.8,79.9 114.8,81.9 108.4,81.9 108.4,86.3 114.2,86.3 114.2,88.2 108.4,88.2 108.4,93.2 114.8,93.2 114.8,95.1 106.3,95.1  "
                    />
                  </g>
                  <path
                    fill="#3c4652"
                    d="M44.6,67.9C44.6,67.9,44.6,68,44.6,67.9c0,0.1,0,0.1,0.1,0.1l0,0l0,0l0.2,0h0c4.6,1.2,10.6,0.9,12.3,0.7 c2.6-0.2,5.7,0,7.3,0.2c0,0,0.1,0,0.1-0.1l0,0c0,0,0-0.1-0.1-0.1c-1.4-0.2-6.3-0.9-9-0.7c-2.5,0.2-5.9,0.1-10.7-0.2 C44.8,67.9,44.8,67.9,44.6,67.9L44.6,67.9C44.7,67.8,44.6,67.9,44.6,67.9"
                  />
                  <path
                    fill="#3c4652"
                    d="M133,71.8c-0.4-0.4-1.1-0.3-1.6-0.3c-0.3,0-0.6,0.1-0.7,0c-1.7-1.4-2.5-0.9-3.6-0.2 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.6,0.3c-0.4,0.2-0.9,0.4-1.4,0.6c-0.7,0.2-1.6,0.2-2.7,0.1c-1.8-0.2-4.1-1.2-6.5-2.4 c-3.5-1.7-7.5-3.5-11.3-3.3c-6.4,0.4-8.7-0.2-15.2-4c-8.4-4.7-13-6.3-19.8-3.4c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.1-0.7,0.3-1.1,0.4 c-0.2,0.1-0.4,0.1-0.6,0.2c-4.9,1.7-7.4,0.6-12.5-1.7l-4-1.7c-8.5-3.6-11-2.2-13,1.9c-1.2,2.6-2.5,4.3-3.7,5.2 c-0.6-1.6-2.3-2.8-3.6-3.1c-2.2-0.5-3.6-1.2-3.9-1.4c0,0-1.2-1.5-3.5-1.8c-2.5-0.4-4.3,0.3-5.6,1.3c-1.5,1.2-2.4,3.2-2.2,5.3 c0.4,2.8,2,4.5,2,4.5c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-0.8-1-1.3-2-1.5-3.7c-0.1-1.7,0.3-3.6,1.7-4.9c1.7-1.5,3.8-1.7,5.6-1.3 c2.2,0.6,3.3,2.8,4,4.7c0.7,2.1,1.5,4.3,5,4c2-0.1,3.7,0.8,4.5,2.5c0.8,1.7,0.2,3.7-1.5,5.3c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0 l0.8-0.8c1.6-1.7,1.9-3.7,1.1-5.5c-0.7-1.6-2.4-2.5-4.4-2.4c-3.6,0.1-4.1-1.7-4.7-3.7c-0.3-0.9-0.6-1.7-1.2-2.5 c0.7,0.5,1.6,0.8,3,1.1c1.2,0.3,2.7,1.3,3.4,2.7c-0.1,0-0.3,0.1-0.5,0.2c-0.9,0.2-1.8,0-2.8-0.7c-0.1,0-0.2-0.1-0.2-0.2l0,0 c0,0-0.1,0-0.1,0v0c0,0,0,0,0,0.1l0,0l0.2,0.1c0,0,0,0,0.1,0c0.8,0.6,2,1.2,3.4,0.9c1.6-0.4,3.1-2.1,4.6-5.2 c1.8-3.8,3.5-5.1,12.1-1.7c1.8,0.7,3.3,1.4,4.7,1.9c4.8,2.2,7,3,12.7,0.7c0.5-0.2,1.1-0.4,1.6-0.6c6.1-2.2,11.3-0.3,19.4,4.4 c4.9,2.9,8,3,11.8,3.2c1.3,0.1,2.7,0.1,4.2,0.3c4.3,0.5,7.4,2,10.1,3.3l0,0c-7.3-2.5-10.5-1.8-13.5-1.2c-1.8,0.4-3.5,0.7-5.8,0.2 c-10-2.3-13.8-1.7-16.1-1.2c0.6-0.7,0.8-1.7,0.7-2.8c-0.1-0.8-0.3-1.7-0.8-2.6c0,0,0,0-0.1,0h0c0,0,0,0,0,0.1c0,0,0,0,0,0 c0.3,0.6,0.4,1.2,0.5,1.7c0.2,1.8-0.7,3.3-1.9,4.1c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0,0.1c0.4,0.1,0.8,0.6,1.1,1.2 c0.2,0.4,0.3,0.9,0.4,1.5c0.1,0.9,0,1.9-0.4,2.9v0c0,0,0,0,0,0.1c0,0,0.1,0,0.1,0l0,0l0,0l0,0c0.7-1,1-2.6,0.9-3.9 c0-0.2-0.1-0.5-0.1-0.7c-0.1-0.3-0.2-0.6-0.3-0.7l0,0l0.3,0c2.3-0.4,5.7-1.1,15.9,0.9c2.3,0.4,4,0.2,5.8,0 c3.3-0.4,7.3-0.9,17.2,2.2l0,0c0.7,0.2,1.3,0.4,2,0.4c1.9,0.2,3.2-0.1,4.2-0.6c0.8-0.2,1.4-0.5,1.9-0.8c1.2-0.5,2.1-0.7,3.5,0.5 c0.2,0.2,0.6,0.1,1,0c0.6-0.1,1.2-0.2,1.6,0.2c0.5,0.4,0.3,1.9,0.3,2.7c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1-0.1v0l0,0 c0-0.3,0.2-1.7,0.2-1.9C133.4,72.6,133.2,72.1,133,71.8"
                  />
                  <path
                    fill="#3c4652"
                    d="M33.5,68.8c-2-1.3-4.7-0.3-7.2,0.9c-5.9,2.9-6.3,0-10.9,0c-2.4,0-2.7,2-2.7,2.7s0.2,2,0.6,2.9l0,0l0,0l0,0 c0,0,0.1,0.1,0.1,0c0,0,0.1-0.1,0-0.1c-0.5-1.3-0.6-4.2,2-4.2c4.1,0,5.2,3,11.1-0.1c2.2-1.2,4.2-2,6-0.8c1.2,0.8,1.8,2.9,0.8,5.1 c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0.1-0.1c0,0,0,0,0,0C35.3,72.3,35.7,70.3,33.5,68.8"
                  />
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div className="fix-white"></div>
      </div>
    </div>
  );
}
export default HeaderUser;
